export default "__VITE_ASSET__YQ65tbtN__"